/**
 * @generated SignedSource<<8c2ba18bd76734453bf0cc848e4b6178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarPromotion_transaction$data = {
  readonly mostRecentOffer: {
    readonly quantity: number | null;
  } | null;
  readonly promotions: ReadonlyArray<{
    readonly code: string | null;
    readonly isInvalid: boolean | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarPromotionForm_transaction">;
  readonly " $fragmentType": "CheckoutSidebarPromotion_transaction";
};
export type CheckoutSidebarPromotion_transaction$key = {
  readonly " $data"?: CheckoutSidebarPromotion_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarPromotion_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarPromotion_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotionForm_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "mostRecentOffer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInvalid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "e9b2efc03bbdf178fe99ca107fa4f8cd";

export default node;
